import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=cd965784&scoped=true"
import script from "./OrderListItem.vue?vue&type=script&lang=ts"
export * from "./OrderListItem.vue?vue&type=script&lang=ts"
import style0 from "./OrderListItem.vue?vue&type=style&index=0&id=cd965784&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd965784",
  null
  
)

export default component.exports